module.exports = __webpack_public_path__ + "static/media/iblu3.fc586f82.gif";